import { Div, Icon, Text } from "atomize"
import { theme } from "../settings/config"
import { Fragment, useContext, useState } from "react"
import { motion } from "framer-motion"
import { schoolContext } from "../providers/school.provider"
import Dropdown from "../atomize/Dropdown"
import Divider from "../atoms/Divider"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStar } from "@fortawesome/free-solid-svg-icons"
import { canSwitchSchool } from "../utils/func.utils"
import SchoolAvatar from "./SchoolAvatar"

// Le voci del menu dei circoli, una per circolo: il tondo e il nome intero,
// che sul telefono è il solo posto dove si legge. Le usano la fascia qui
// sotto, sul computer, e il tondo del circolo in cima al telefono.
//
// I circoli sono quelli che il provider mette nel selettore, nel suo
// ordine: il principale per primo, con la stellina, e gli archiviati no —
// salvo quello che si sta guardando, che lo dice.
export const schoolMenuItems = ({
	schools,
	schoolIDs,
	selectedSchoolID,
	primarySchoolID,
	isArchived = () => false,
	onPick,
}) =>
	schoolIDs.map((schoolID, i) => (
		<Fragment key={schoolID}>
			<Div
				d="flex"
				align="center"
				p="0.6rem 1rem"
				cursor="pointer"
				style={{ gap: "0.65rem" }}
				aria-current={schoolID === selectedSchoolID ? "true" : undefined}
				onClick={() => onPick(schools[schoolID].schoolID)}>
				<SchoolAvatar school={schools[schoolID]} size={28} />
				<Div style={{ maxWidth: "16rem", minWidth: 0 }}>
					<Text textWeight={schoolID === selectedSchoolID ? "bold" : "normal"}>
						{schools[schoolID]?.schoolName}
						{schoolID === primarySchoolID && (
							<FontAwesomeIcon
								icon={faStar}
								color={theme.colors.primary}
								title="Principale"
								style={{ marginLeft: "0.4rem", fontSize: "0.75em" }}
							/>
						)}
					</Text>
					{isArchived(schoolID) && (
						<Text textSize="caption" textColor={theme.colors.text_light}>
							Archiviato
						</Text>
					)}
				</Div>
			</Div>
			{i < schoolIDs.length - 1 && (
				<Divider m={{ x: "0.5rem" }} w="2px solid" borderColor={theme.colors.background} />
			)}
		</Fragment>
	))

// La fascia in cima allo schermo con cui si passa da un circolo all'altro,
// sul computer. Sul telefono il circolo sta nella fascia comune in cima
// (vedi header/PhoneHeader).
function SchoolSwitcher() {
	const {
		schools,
		schoolIDs,
		primarySchoolID,
		isArchivedSchool,
		selectedSchool,
		getSelectedSchool,
		setSelectedSchool,
	} = useContext(schoolContext)

	const [isOpen, setIsOpen] = useState(false)

	if (!canSwitchSchool(schoolIDs)) return null

	return (
		<>
			<motion.div
				style={{
					width: "calc(100% - 13.5rem)",
					position: "fixed",
					top: "-1rem",
					zIndex: "2",
				}}
				whileTap={{ y: "0.5rem" }}
				initial={{ y: -20 }}
				animate={{ y: 0 }}
				exit={{ y: -20 }}>
				<Dropdown
					d="flex"
					align="center"
					justify="center"
					p={{ t: "2.5rem", b: "1.5rem" }}
					m="0"
					rounded="bottomOnly"
					shadow={theme.shadows.accent}
					bg="primary"
					focusBg="primary"
					direction="bottomcenter"
					borderColor={theme.colors.primary}
					focusBorderColor={theme.colors.primary}
					textColor={"white"}
					isOpen={isOpen}
					openSuffix={<Icon name="UpArrow" size="18px" color="white" />}
					closeSuffix={<Icon name="DownArrow" size="18px" color="white" />}
					style={{ gap: "0.25rem" }}
					onClick={() => setIsOpen(!isOpen)}
					menu={schoolMenuItems({
						schools,
						schoolIDs,
						isArchived: isArchivedSchool,
						selectedSchoolID: selectedSchool,
						primarySchoolID,
						onPick: schoolID => {
							setSelectedSchool(schoolID)
							setIsOpen(false)
						},
					})}>
					<Div
						d="flex"
						align="center"
						justify="center"
						style={{ gap: "0.5rem" }}
						textWeight="normal">
						<SchoolAvatar school={getSelectedSchool()} size={26} tone="onPrimary" />
						<Text textAlign="left">{getSelectedSchool()?.schoolName}</Text>
					</Div>
				</Dropdown>
			</motion.div>
			<Div h="3rem" pos="relative" />
		</>
	)
}

export default SchoolSwitcher
